export default {
  employees: {
    searchDepartments: 101792, // Search Departments
    searchJobs: 101860, // Search Jobs
    searchTeams: 101795, // Search Teams
  },
};
